import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { NzIconModule } from 'ng-zorro-antd/icon'

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.less'],
  standalone: true,
  imports: [CommonModule, RouterModule, NzIconModule],
})
export class AccountComponent {
  tabs: { label: string; route: string; icon: string }[] = [
    { label: 'Dashboard', route: 'dashboard', icon: 'dashboard' },
    { label: 'Achievements', route: 'achievements', icon: 'achievements' },
    { label: 'Keys', route: 'keys', icon: 'key' },
    { label: 'Settings', route: 'settings', icon: 'settings' },
  ]
  selectedTab = this.tabs[3].route
  accounts = [
    'Connect your Xbox',
    'Connect your Google',
    'Connect your Facebook',
    'Connect your Nintendo',
    'Connect your Steam',
    'Connect your Playstation',
    'Connect your Epic Games',
    'Connect your Riot',
    'Connect your Twitch',
  ]

  constructor(private route: Router) {}

  onTabClick(tab: { label: string; route: string }) {
    if (tab.route === '') return
    this.selectedTab = tab.route
    this.route.navigate(['account', tab.route])
  }
}
